import React from "react";
import ReactSelect, {components as selectComponents, ControlProps, Props} from 'react-select'
import ReactAsyncSelect from 'react-select/async';
import ReactAsyncCreatSelect from 'react-select/async-creatable';
import './Select.scss'
import IconLocation from "@images/icons/location.svg";

export interface ListOption {
  readonly value: string;
  readonly label: string;
  readonly type: string;
}

export const LocationIcon = ({type}: {type: string}) => {

  switch (type) {
    case 'place': return <img src={IconLocation} alt={''}/>;
    case 'municipality': return <img src={IconLocation} alt={''}/>;
    case 'province': return <img src={IconLocation} alt={''}/>;
  }
}

export const Select = (
  {
    dataTestid,
    onChange,
    isAsync,
    isCreatable,
    components,
    ...props
  }: Omit<Props, 'onChange'> & {
    dataTestid: string
    placeholder?: any
    onChange?: (input: ListOption[] | ListOption) => void
    className?: string
    isAsync?: boolean
    isCreatable?: boolean
    components?: any

    // Optional async props
    defaultOptions?: any;
    cacheOptions?: any;
    loadOptions?: any;
    isLoading?: any;

  }) => {

  const Control = ({ children, ...controlProps }: {children: any}) => {
    return <div data-testid={dataTestid}>
      <selectComponents.Control {...controlProps as ControlProps}>
      {children}
    </selectComponents.Control>
    </div>
  };

  const CoreElement = isAsync ? isCreatable ? ReactAsyncCreatSelect : ReactAsyncSelect : ReactSelect


  return <CoreElement
    cacheOptions
    placeholder={props.placeholder || ''}
    className="rs-container"
    classNamePrefix="rs"
    components={{
      ...components,
      Control,
  }}
    onChange={(e) => {
      const input = e as ListOption[]
      onChange && onChange(input)
    }}
    {...props} />
};


export default Select
